import classNames from "classnames";
import React, { useMemo, useState } from "react";
import { Content, DisplayEPGS, LikesData } from "../globalType";
import { displayDuration, displayNumber, getContentUrl, share } from "../utils";
import ImageWithFallback from "./ImageWithFallback";

declare var $: any;

type Props = {
  content: DisplayEPGS | null;
  goToPage: (page: string, content: Content | null) => void;
};

export function LiveModal(props: Props) {
  const { goToPage, content } = props;
  return (
    <>
      <div
        className="modal fade liveModal-BG"
        id="liveModal"
        tabIndex={-1}
        aria-labelledby="liveModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <ImageWithFallback
                    src={content ? content.thumb: '/ondemand/static/img/default_channel.jpg'}
                    alt="movie"
                    maxWidth={0}
                    fallbackSrc="/ondemand/static/img/default_channel.jpg"
                  />
              <button
                type="button"
                className="btn-close xBT"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="text-BG">
                <h1 className="m-0">{content?.title}</h1>
                <p>
                  <img src="/ondemand/static/img/d-video.png" alt="" style={{marginRight: '1rem'}} />
                  {content?.displayDay} {content?.displayStart} - {content?.displayEnd}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
